import Tooltip from "flowbite/lib/esm/components/tooltip"
import PopperBase from "./popper_base"

// Flowbite tooltip on its trigger — see popper_base.js.
//
//   <span data-controller="tooltip" data-tooltip-id-value="hint">…</span>
//   <div id="hint" role="tooltip">…</div>
export default class extends PopperBase {
  static values = {
    placement: { type: String, default: "top" },
    triggerType: { type: String, default: "hover" },
  }

  _create(target, instanceId) {
    return new Tooltip(
      target,
      this.element,
      { placement: this.placementValue, triggerType: this.triggerTypeValue },
      { id: instanceId, override: false },
    )
  }
}
